export const BLOCK_LINK_ERROR =
  "Use an https:// link, a path starting with /, a #anchor, a mailto: link or a tel: link";

const WHITESPACE_OR_CONTROL_CHARACTER = /[\s\p{Cc}]/u;

const ANCHOR = /^#[a-z0-9-]+$/;

const TELEPHONE = /^tel:\+?(?=[0-9-]*[0-9])[0-9-]+$/;

const MAILTO_ADDRESS = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;

const PERCENT_ENCODED_VALUE = /^(?:[A-Za-z0-9\-._~!$'()*+,;:@/]|%[0-9A-Fa-f]{2})*$/;

const MAILTO_FIELDS = new Set(["subject", "body"]);

export function isHttpsUrl(href: string): boolean {
  if (!href.startsWith("https://") || !URL.canParse(href)) {
    return false;
  }

  return new URL(href).hostname !== "";
}

function isSitePath(href: string): boolean {
  return href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/\\");
}

function isMailto(href: string): boolean {
  const [address, query, ...rest] = href.slice("mailto:".length).split("?");

  if (rest.length > 0 || !MAILTO_ADDRESS.test(address)) {
    return false;
  }

  if (query === undefined) {
    return true;
  }

  const seen = new Set<string>();

  return query.split("&").every(pair => {
    const [name, value, ...extra] = pair.split("=");

    if (extra.length > 0 || value === undefined || !MAILTO_FIELDS.has(name) || seen.has(name)) {
      return false;
    }

    seen.add(name);

    return PERCENT_ENCODED_VALUE.test(value);
  });
}

export function isValidBlockLink(href: string): boolean {
  if (href === "" || WHITESPACE_OR_CONTROL_CHARACTER.test(href)) {
    return false;
  }

  if (href.startsWith("#")) {
    return ANCHOR.test(href);
  }

  if (href.startsWith("/")) {
    return isSitePath(href);
  }

  if (href.startsWith("mailto:")) {
    return isMailto(href);
  }

  if (href.startsWith("tel:")) {
    return TELEPHONE.test(href);
  }

  return isHttpsUrl(href);
}
